
import { createSlice } from '@reduxjs/toolkit';

const getUserNotificationConsentDetailsSlice = createSlice({
  name: 'getUserNotificationConsentDetails',
  initialState: {
    loading: false,
    userNotificationConsentDetails: null,
    error: null,
    success: false,
  },
  reducers: {
    getUserNotificationConsentDetailsRequest(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    getUserNotificationConsentDetailsSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.success = true;
      state.userNotificationConsentDetails = action.payload;
    },
    getUserNotificationConsentDetailsFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
  },
});

export const {
  getUserNotificationConsentDetailsRequest,
  getUserNotificationConsentDetailsSuccess,
  getUserNotificationConsentDetailsFailure,
} = getUserNotificationConsentDetailsSlice.actions;
export default getUserNotificationConsentDetailsSlice.reducer;